// action for sharebot enable or disable
export const ENABLE_SHAREBOT = 'ENABLE_SHAREBOT'
export const DISABLE_SHAREBOT = 'DISABLE_SHAREBOT'

export const enableShareBot = () => ({
    type: ENABLE_SHAREBOT
})

export const disableShareBot = () => ({
    type: DISABLE_SHAREBOT
})

